import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const ContentTemplate = React.lazy(() =>
    import('../ContentTemplate')
);
const contentTemplateRoutesRegistry = [
    {
        path: PAGE_URL.CONTENT_TEMPLATE_PAGE,
        element: <ContentTemplate />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default contentTemplateRoutesRegistry;
